import { DateTime } from 'luxon';
import useAgentTimeZone from 'hooks/useAgentTimeZone';
import { BusinessHealthPeriod } from '../types';
import {
    PeriodCaption,
    PeriodCaptionLabel,
    PeriodCaptionValueRow,
    PeriodCaptionDates,
    PeriodCaptionDays,
} from './styled';

export interface ReportingPeriodCaptionProps {
    period: BusinessHealthPeriod;
}

const ReportingPeriodCaption = ({ period }: ReportingPeriodCaptionProps) => {
    const timeZone = useAgentTimeZone();
    const { current, days } = period;

    const fromDate = DateTime.fromISO(current.start).setZone(timeZone, { keepLocalTime: true });
    const toDate = DateTime.fromISO(current.end).setZone(timeZone, { keepLocalTime: true });
    const rangeText = `${fromDate.toFormat('LLL d, yyyy')} – ${toDate.toFormat('LLL d, yyyy')}`;
    const showDays = days != null && days >= 0;

    return (
        <PeriodCaption aria-label="Reporting period">
            <PeriodCaptionLabel>Reporting period</PeriodCaptionLabel>
            <PeriodCaptionValueRow>
                <PeriodCaptionDates>{rangeText}</PeriodCaptionDates>
                {showDays && (
                    <PeriodCaptionDays>
                        {days}
                        {' '}
                        {days === 1 ? 'day' : 'days'}
                    </PeriodCaptionDays>
                )}
            </PeriodCaptionValueRow>
        </PeriodCaption>
    );
};

export default ReportingPeriodCaption;
